import React from "react";
import { Package, Flag } from "lucide-react";

const PRINTER =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/41pladw1_PSP%2036IO.webp";
const LAMINATOR =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/qmx2m91b_Hot%20Laminator.jpg";
const CUTTER =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/3cmlrd8a_ETD%20Vinyl%20Cutter.webp";

const SECONDARY = [
  {
    title: "1–2 Year Supply Kit",
    eyebrow: "Ink · paper · media",
    body: "Long-term supply coverage so you're never left without.",
    icon: Package,
  },
  {
    title: "Laminator",
    eyebrow: "Hot or cold",
    body: "Protect and preserve posters, signage, and displays.",
    img: LAMINATOR,
    isImage: true,
  },
  {
    title: "Vinyl Cutter",
    eyebrow: "Decals & lettering",
    body: "Cut custom graphics for walls, windows, and doors.",
    img: CUTTER,
    isImage: true,
  },
  {
    title: "Banner Finishing Kit",
    eyebrow: "Optional add-on",
    body: "Grommets, hems, pole pockets, and hanging accessories.",
    icon: Flag,
  },
];

export default function BundlesIncluded() {
  return (
    <section
      id="bundles-included"
      data-testid="bundles-included-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            What's included
          </div>
          <h2
            data-testid="bundles-included-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            One Complete System
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            Every bundle is sized and matched to your school. Here's what's
            inside.
          </p>
        </div>

        {/* Featured Printer card */}
        <div
          data-testid="bundles-included-item-0"
          className="group relative bg-white border border-slate-200 hover:border-teal/40 rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl mb-5 lg:mb-6 grid grid-cols-1 lg:grid-cols-5"
        >
          <div className="cmyk-ribbon h-1 w-full absolute top-0 left-0" aria-hidden />
          <div className="relative lg:col-span-3 bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-8 sm:p-12 min-h-[280px] lg:min-h-[360px]">
            <span className="absolute top-6 left-6 text-[10px] uppercase tracking-[0.18em] font-bold bg-teal text-white px-2.5 py-1 rounded-full z-10">
              Core
            </span>
            <img
              src={PRINTER}
              alt="Canon wide-format poster & banner printer"
              loading="lazy"
                decoding="async"
              className="max-w-full max-h-[260px] lg:max-h-[320px] object-contain transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="lg:col-span-2 p-8 md:p-10 lg:p-12 flex flex-col justify-center border-t lg:border-t-0 lg:border-l border-slate-200">
            <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-teal mb-3">
              24" · 36" · 44"
            </span>
            <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-navy mb-4 leading-tight">
              Poster & Banner Printer
            </h3>
            <p className="text-base text-slate-600 leading-relaxed">
              Wide-format Canon printer sized to your school's printing volume.
              Choose from three widths to match your needs.
            </p>
          </div>
        </div>

        {/* 4 secondary items */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {SECONDARY.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                data-testid={`bundles-included-item-${i + 1}`}
                className="group relative bg-white border border-slate-200 hover:border-teal/40 rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl flex flex-col"
              >
                <div className="cmyk-ribbon h-1 w-full" aria-hidden />
                <div className="relative aspect-[4/3] bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-6 overflow-hidden">
                  {item.isImage ? (
                    <img
                      src={item.img}
                      alt={item.title}
                      loading="lazy"
                decoding="async"
                      className="max-w-full max-h-full object-contain transition-transform duration-700 group-hover:scale-105"
                    />
                  ) : (
                    <div className="w-20 h-20 rounded-2xl bg-navy text-white flex items-center justify-center group-hover:bg-teal transition-colors">
                      <Icon className="w-9 h-9" strokeWidth={1.75} />
                    </div>
                  )}
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-teal mb-2">
                    {item.eyebrow}
                  </span>
                  <h3 className="font-serif text-lg md:text-xl font-bold text-navy mb-2 leading-tight">
                    {item.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    {item.body}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
